import { render, staticRenderFns } from "./refuteResourcesCar.vue?vue&type=template&id=2ce369f8&scoped=true&"
import script from "./refuteResourcesCar.vue?vue&type=script&lang=js&"
export * from "./refuteResourcesCar.vue?vue&type=script&lang=js&"
import style0 from "./refuteResourcesCar.vue?vue&type=style&index=0&id=2ce369f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce369f8",
  null
  
)

export default component.exports